'use strict';

var UserExclusionsPanelConfig = function UserExclusionsPanelConfig($stateProvider) {
  $stateProvider.state('app.user-exclusions', {
    url: '/workflow/user-exclusions',
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/user-exclusions-panel.html'),
        controller: 'UserExclusionsPanelController'
      },
      'mainToolbar': {
        template: require('../templates/user-exclusions-toolbar.html'),
        controller: 'UserExclusionsToolbarController'
      }
    }
  });
};
UserExclusionsPanelConfig.$inject = ['$stateProvider'];
module.exports = UserExclusionsPanelConfig;